import React from 'react';
import classNames from 'classnames';
import styles from './StarRating.module.less';
import { RATING_LABELS } from './StarRatingInput';
import { Stars } from './Stars'; // @BUG: Clicking on an SVG viewBox shows an animation but doesn't update with onClick

export var StarRating = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      label = props.label,
      maxRating = props.maxRating,
      nerdwallet = props.nerdwallet,
      rating = props.rating,
      ratingLabels = props.ratingLabels,
      ariaLabel = props['aria-label'];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className),
    ref: ref
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.stars)
  }, label && /*#__PURE__*/React.createElement("span", {
    className: styles.legend
  }, label), /*#__PURE__*/React.createElement(Stars, {
    maxRating: maxRating,
    nerdwallet: nerdwallet,
    rating: rating // Assign role="img" so assistive technologies will
    // interpret this as an image and read the label
    // passed in below.
    ,
    role: "img",
    "aria-label": ariaLabel || ratingLabels && ratingLabels[rating] || "rated ".concat(rating, " out of ").concat(maxRating)
  })));
});
StarRating.displayName = 'StarRating';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  StarRating.propTypes = {
    /**
     * Text to be used for assistive technology (like screen readers) to
     * better guide users to what the context of this element means to
     * the webpage. Defaults to the passed in rating label, then
     * `rated ${rating} out of ${maxRating}`, but can be overriden here.
     */
    'aria-label': PropTypes.string,

    /** Class on the outer container element. */
    className: PropTypes.string,

    /** Label for the stars. */
    label: PropTypes.string,

    /** Maximum star rating. */
    maxRating: PropTypes.number,

    /** Whether this is a "NerdWallet" rating, making the stars green. */
    nerdwallet: PropTypes.bool,

    /** Current star rating. */
    rating: PropTypes.number,

    /** Object mapping each rating value to its label or a flag indicating to hide the rating labels. */
    ratingLabels: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.bool])
  };
}

StarRating.defaultProps = {
  'aria-label': null,
  className: null,
  label: null,
  maxRating: 5,
  nerdwallet: false,
  rating: 0,
  ratingLabels: RATING_LABELS
};